import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/components/Home/Home.vue';
import RouteListener from '@/components/Sport/RouteListener.vue';
import SportHome from '@/components/Sport/SportHome.vue';
import AppDrawer from '@/components/AppDrawer.vue';
import { dispatch } from '@/store';

Vue.use(VueRouter);

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * @param  {string}   name     the filename (basename) of the view to load.
 */
const component = (name: string) => () => import(`../components/${name}.vue`);

const router = new VueRouter({
  routes: [
    {
      path: '/tv-guide',
      name: 'tvGuide',
      component: component('TVGuideFeed/TVGuideFeed'),
    },
    {
      path: '/tv-guide-dstv',
      name: 'tvGuideDStv',
      component: component('TVGuideDStv/TVGuideDStv'),
    },
    {
      path: '/articles/:id',
      name: 'article',
      props: true,
      component: component('Content/Article/ArticleFetcher'),
    },
    {
      path: '/articles/video/:videoId',
      name: 'articleVideo',
      props: (route) => ({ id: route.params.videoId, hasRelatedVideos: false }),
      component: component('Content/Video/VideoFetcher'),
    },
    {
      path: '/video/:id/:tour?',
      name: 'video',
      props: true,
      component: component('Content/Video/VideoFetcher'),
    },
    {
      path: '/event/cricket/:id/status/:statusId',
      name: 'cricket-match',
      props: true,
      component: component('Event/Cricket/CricketMatchFetcher'),
    },
    {
      path: '/event/motorsport/:id',
      name: 'motorsport-race',
      props: true,
      component: component('Event/Motorsport/MotorsportRaceFetcher'),
    },
    {
      path: '/event/tennis/:id',
      name: 'tennis-match',
      props: true,
      component: component('Event/Tennis/TennisMatchResultsFetcher'),
    },
    {
      path: '/event/golf-stroke/:id',
      name: 'golf-stroke-event',
      props: true,
      component: component('Event/Golf/GolfLeaderboardFetcher'),
    },
    {
      path: '/event/golf-matchplay/:id',
      name: 'golf-matchplay-event',
      props: true,
      component: component('Event/Golf/GolfMatchPlayLeaderboardFetcher'),
    },
    {
      path: '/event/rugby/:id/status/:statusId',
      name: 'rugby',
      props: true,
      component: component('Event/Rugby/RugbyMatchDetailsFetcher'),
    },
    {
      path: '/event/football/:id/status/:statusId',
      name: 'football',
      props: true,
      component: component('Event/Football/FootballMatchDetailsFetcher'),
    },
    {
      path: '/',
      component: AppDrawer,
      children: [
        {
          path: '',
          name: 'home',
          component: Home,
        },
        {
          path: '/environment-info',
          name: 'environment-info',
          component: component('EnvInfoPage'),
        },
        {
          path: ':sportFeedId/:tournamentFeedId',
          component: RouteListener,
          props: true,
          children: [
            {
              path: '',
              name: 'sportHome',
              props: true,
              meta: { contextMenuTab: undefined },
              component: SportHome,
            },
            {
              path: 'news',
              name: 'news',
              props: true,
              meta: { contextMenuTab: 'news' },
              component: component('Sport/NewsList'),
            },
            {
              path: 'videos',
              name: 'videos',
              props: true,
              meta: { contextMenuTab: 'videos' },
              component: component('Sport/VideoList'),
            },
            {
              path: 'scores',
              name: 'scores',
              props: true,
              meta: { contextMenuTab: 'scores' },
              component: component('Sport/ScoresList'),
            },
            {
              path: 'top-scorers',
              name: 'top-scorers',
              props: true,
              meta: { contextMenuTab: 'top-scorers' },
              component: component('Sport/TopScorers'),
            },
            {
              path: 'table',
              name: 'table',
              props: true,
              meta: { contextMenuTab: 'table' },
              component: component('Sport/Table'),
            },
            {
              path: 'rankings',
              name: 'rankings',
              props: (route) => ({
                ...route.params,
                type: 'single',
              }),
              meta: { contextMenuTab: 'rankings' },
              component: component('Sport/Tennis/Rankings'),
            },
            {
              path: 'race',
              name: 'race',
              props: (route) => ({
                ...route.params,
                type: 'race',
              }),
              meta: { contextMenuTab: 'race' },
              component: component('Sport/Tennis/Rankings'),
            },
            {
              path: 'driver-standings',
              name: 'driver-standings',
              props: true,
              meta: { contextMenuTab: 'driver-standings' },
              component: component('Sport/Motorsport/DriverStandings'),
            },
            {
              path: 'team-standings',
              name: 'team-standings',
              props: true,
              meta: { contextMenuTab: 'team-standings' },
              component: component('Sport/Motorsport/TeamStandings'),
            },
            {
              path: 'fedex-cup-standings',
              name: 'fedex-cup-standings',
              props: true,
              meta: { contextMenuTab: 'fedex-cup-standings' },
              component: component('Sport/Golf/GolfRaceFedEx'),
            },
            {
              path: 'order-of-merit',
              name: 'order-of-merit',
              props: (route) => ({
                ...route.params,
                shouldDisplayMoney: true,
                currency: 'ZAR',
              }),
              meta: { contextMenuTab: 'order-of-merit' },
              component: component('Sport/Golf/GolfOrderOfMerit'),
            },
            {
              path: 'money-list',
              name: 'money-list',
              props: (route) => ({
                ...route.params,
                shouldDisplayMoney: true,
              }),
              meta: { contextMenuTab: 'money-list' },
              component: component('Sport/Golf/GolfOrderOfMerit'),
            },
            {
              path: 'race-to-dubai',
              name: 'race-to-dubai',
              props: true,
              meta: { contextMenuTab: 'race-to-dubai' },
              component: component('Sport/Golf/GolfOrderOfMerit'),
            },
          ],
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  dispatch('setCurrentRoute', [to]);
  next();
});

export default router;
